/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * All possible Method Not Allowed problems.
 */
export type MethodNotAllowedProblems =
    | Truvity.MethodNotAllowedProblems.MethodNotAllowed
    | Truvity.MethodNotAllowedProblems.MethodNotAllowedResourceAlive
    | Truvity.MethodNotAllowedProblems.MethodNotAllowedResourceDeleted;

export namespace MethodNotAllowedProblems {
    export interface MethodNotAllowed extends Truvity.ProblemMethodNotAllowed {
        type: '/method-not-allowed';
    }

    export interface MethodNotAllowedResourceAlive extends Truvity.ProblemMethodNotAllowedResourceAlive {
        type: '/method-not-allowed/resource/alive';
    }

    export interface MethodNotAllowedResourceDeleted extends Truvity.ProblemMethodNotAllowedResourceDeleted {
        type: '/method-not-allowed/resource/deleted';
    }
}
